import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  input,
  model,
  output,
  signal,
  untracked
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { AiPreviewHandlerComponent, SiaAIChatService } from '@sia/ai';
import { SiaFileDossier, SiaGridFile } from '../../interfaces/grid-file';
import { AiGridFileInformationViewComponent } from '../ai-grid-file-information-view/ai-grid-file-information-view.component';
import { RelatedFilesGridComponent } from '../related-files-grid/related-files-grid.component';

@Component({
  selector: 'sia-ai-file-grid-details',
  host: {
    class: 'flex h-full w-full',
  },
  imports: [
    MatTabsModule,
    AiPreviewHandlerComponent,
    RelatedFilesGridComponent,
    MatIconModule,
    CommonModule,
    MatProgressSpinner,
    AiGridFileInformationViewComponent,
  ],
  templateUrl: './ai-file-grid-details.component.html',
  styleUrl: './ai-file-grid-details.component.scss',
})
export class AiFileGridDetailsComponent {

  #aiChatService = inject(SiaAIChatService);

  file = input<SiaGridFile | undefined>(undefined);
  #removeDossierFile = effect(() => {
    this.file();
    untracked(() => {
      this.dossierFile.set(undefined);

    });
  });
  dossierFile = signal<SiaGridFile | undefined>(undefined);
  selectedFiles = input<SiaGridFile[] | undefined>(undefined);
  activeTabIndex = computed<number>(() => (this.showPreview() ? 0 : 1));
  imagesUrl = signal<string[]>([]);
  showPreview = model<boolean>(false);
  showFileName = input<boolean>(true);
  viewMode = model<'dossier' | 'standard'>('standard');
  dossier = model<SiaFileDossier>({});
  fileRemovedFromDossier = output<SiaGridFile>();
  loadingPreview = signal<boolean>(false);

  showDossierFilePreview($event: SiaGridFile) {
    this.dossierFile.set($event);
    this.loadingPreview.set(true);
  }
  constructor() {
  }
}
